// @ts-strict-ignore
import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-admin-pagination',
    templateUrl: './admin-pagination.component.html',
    styleUrls: ['./admin-pagination.component.scss'],
    standalone: false
})
export class AdminPaginationComponent implements OnInit {
  @Input() tableData = [];
  @Input() currentItemsPerPage: number = 50;
  @Input() currentPage: number = 1;
  @Input() totalItems: number;
  @Output() pageChangeEvent = new EventEmitter();
  @Output() itemsPPChangeEvent = new EventEmitter();

  public pages = [];
  public page = 1;
  public itemsPerPage = 50;
  public totalPages = 0;
  public paginationStart = 1;
  public paginationEnd: number;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tableData']) {
      this.updatePagination();
    }
    // if component is on same page twice, this syncs current page between all instances
    if (changes['currentPage'] && changes['currentPage'].currentValue !== this.page) {
      this.page = changes['currentPage'].currentValue;
    }
    if (
      changes['currentItemsPerPage'] &&
      changes['currentItemsPerPage'].currentValue !== this.itemsPerPage
    ) {
      this.itemsPerPage = changes['currentItemsPerPage'].currentValue;
      this.updateTotalPages();
    }
  }

  // run when page button clicked
  public changePage(page: number) {
    if (!isNaN(page)) {
      this.page = page;
      this.pageChangeEvent.emit(page);
    }
  }

  public changeItemsPerPage() {
    this.updateTotalPages();
    this.itemsPPChangeEvent.emit(this.itemsPerPage);
  }

  private updatePagination() {
    this.updateTotalPages();
    // set pages to view
    this.pages = this.getRange();
    // tslint:disable-next-line:no-increment-decrement
    for (let i = this.paginationStart; i <= this.paginationEnd; i++) {
      this.pages.push(i);
    }
  }

  private updateTotalPages() {
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
  }

  private getRange(): (number | string)[] {
    // credit https://gist.github.com/kottenator/9d936eb3e4e3c3e02598
    const current = this.page;
    const last = this.totalPages;
    const delta = 2;
    const left = current - delta;
    const right = current + delta + 1;
    const range = [];
    const rangeWithDots = [];
    let l: number;

    for (let i = 1; i <= last; i++) {
      if (i === 1 || i === last || (i >= left && i < right)) {
        range.push(i);
      }
    }

    for (const i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  }
}
